import React from 'react';
import { capitalize } from '../../../Helpers/StringHelper';
import { P3, P3Bold } from './Text';

// Example usage: where 'current_type' matches the value or label prop for a tab item, and changeType sets the current_type variable with state.

{/* <Tabs value={this.state.current_type} onChange={(e) => {this.changeType(e.currentTarget.dataset.id)}}>
<TabItem label="All" value="all"/>
<TabItem label="Requests" value="requests"/>
<TabItem label="Confirmed"/>
<TabItem label="Completed"/>
<TabItem label="Cancelled"/>
</Tabs> */}

// TabItem's 'value' prop is optional and takes precedence over label when determining state

const Tabs = (props) => {

    return (
        <div className="ds-tabs-container" style={{width: (props.children.length * 96) + ((props.children.length - 1) * 8)}}>
            {props.children.map((child) => {
                if (props.value == child.props.value || props.value == child.props.label) {
                    return (
                        <React.Fragment key={child.props.value ? child.props.value : child.props.label}> 
                            {React.cloneElement(child, { active: true, onChange: props.onChange })} 
                        </React.Fragment>
                    )
                } else {
                    return (
                        <React.Fragment key={child.props.value ? child.props.value : child.props.label}> 
                            {React.cloneElement(child, { active: false, onChange: props.onChange })}
                        </React.Fragment>
                    )
                }
            })}
        </div>
    )
}

const TabItem = (props) => {
    const label = props.capitalize ? capitalize(props.label) : props.label;

    return (
        <div
            className={"ds-tab-item" + (props.active ? " active " : "")}
            data-id={props.value ? props.value : props.label}
            onClick={props.onChange}
        >
            {props.active ? (
                <P3Bold>{label}</P3Bold>
            ) : (
                <P3>{label}</P3>
            )}
        </div>
    )
}

export {Tabs, TabItem};